import React from "react";
import styled from "styled-components";

import SummaryContainer from "./SummaryContainer";
import ExpectNumber from "./ExpectNumber";
import ExpectVolume from "./ExpectVolume";
import LastLunch from "./LastLunch";
import LastDinner from "./LastDinner";

export default function Daily() {
  return (
    <DailyContainer>
      <SummaryContainer /> {/* 상단 위치한 서머리 정보 카드들 */}
      <FirstContainer>
        <ExpectNumber />  {/* 예상 식수인원 카드 */}
        <ExpectVolume />  {/* 예상 식사 준비량 카드 */}
      </FirstContainer>
      <SecondContainer>
        <LastLunch />  {/* 이전 점심 카드*/}
        <LastDinner /> {/* 이전 저녁 카드 */}
      </SecondContainer>
    </DailyContainer>
  );
}

const DailyContainer = styled.div`
  display: flex;
  flex-direction: column;

  align-items: stretch;
  align-content: center;

  @media (min-width: 1200px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const FirstContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 10px;
  border: 3px solid white;
  flex: 1;

  @media (min-width: 1200px) {
    flex: 2 1 700px;
    height: 80vh;
  }
`;

const SecondContainer = styled(FirstContainer)`
  @media (min-width: 1200px) {
    margin-left: 10px;
    flex: 1 1 350px;
  }
`;
